/**
 * SeasonalChip — small amber pill rendered next to seasonal DI titles
 * across the v2 calendar (DailyInspirationsTableV2) and the swap picker
 * (DailyInspirationReassignModal).
 *
 * Extracted out of those two files because the markup + inline styles
 * had drifted into two identical copies (Cursor Bugbot on PR #410). One
 * source of truth, one place to retheme.
 *
 * The amber palette (#FAEBD0 background, #8A6A1F text) is intentionally
 * picked outside the design system's teal/navy tokens — seasonal is a
 * special-case scheduling state ("excluded from the Feb 29 fallback
 * pool"), not a regular content category, so it should read distinctly
 * from the rest of the row.
 */
import React from "react";

export default function SeasonalChip({ className = "" }) {
  return (
    <span
      className={`uppercase font-bold shrink-0 ${className}`.trim()}
      title="Seasonal — excluded from Feb 29 fallback"
      style={{
        fontSize: 9.5,
        letterSpacing: "0.05em",
        padding: "1px 6px",
        borderRadius: 4,
        background: "#FAEBD0",
        color: "#8A6A1F",
      }}
    >
      Seasonal
    </span>
  );
}
